import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { Button } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import type { ConsentDeleteTarget } from "../consentGovernanceTypes";

export type { ConsentDeleteTarget } from "../consentGovernanceTypes";

type ConsentDeleteDialogProps = {
    isDeleting: boolean;
    onClose: () => void;
    onConfirm: () => void;
    open: boolean;
    target?: ConsentDeleteTarget;
};

export const ConsentDeleteDialog = ({ isDeleting, onClose, onConfirm, open, target }: ConsentDeleteDialogProps) => {
    const { t } = useTranslation();

    const message =
        target?.kind === "item" ?
            target.item.type === "document" ?
                t(
                    "settings.consent.delete.document_confirm",
                    'Are you sure you want to delete the document "{{name}}"? This action cannot be undone.',
                    { name: target.item.name },
                )
            :   t(
                    "settings.consent.delete.preference_confirm",
                    'Are you sure you want to delete the preference "{{name}}"? This action cannot be undone.',
                    { name: target.item.name },
                )
        : target?.kind === "items" ?
            t(
                "settings.consent.delete.items_confirm",
                "Are you sure you want to delete {{count}} item(s)? This action cannot be undone.",
                { count: target.items.length },
            )
        : target?.kind === "version" ?
            t(
                "settings.consent.delete.version_confirm",
                'Are you sure you want to delete version "{{version}}"? This action cannot be undone.',
                { version: target.version.version },
            )
        : target?.kind === "versions" ?
            t(
                "settings.consent.delete.versions_confirm",
                "Are you sure you want to delete {{count}} version(s)? This action cannot be undone.",
                { count: target.versions.length },
            )
        :   "";

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>{t("common.actions.confirmDelete", "Confirm deletion")}</DialogTitle>
            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={isDeleting}>
                    {t("common.actions.cancel", "Cancel")}
                </Button>
                <Button onClick={onConfirm} color="error" variant="contained" disabled={isDeleting}>
                    {t("common.actions.delete", "Delete")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
